import { render, staticRenderFns } from "./Integrately.vue?vue&type=template&id=3f37c986&scoped=true"
import script from "./Integrately.vue?vue&type=script&lang=js"
export * from "./Integrately.vue?vue&type=script&lang=js"
import style0 from "./Integrately.vue?vue&type=style&index=0&id=3f37c986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f37c986",
  null
  
)

export default component.exports